/**
 * Thrown when a domain integrity precondition is violated (e.g. a referenced
 * entity does not exist, or a business rule rejects the input). Carries optional
 * structured `details` for diagnosis. The domain never ignores such cases silently.
 */
export class ValidationException extends Error {
    constructor(message, details) {
        super(message);
        this.details = details;
        this.name = 'ValidationException';
    }
}
//# sourceMappingURL=validationException.js.map